import { strings } from "@src/i18n/strings";

const errorStrings = strings.components.friendlyError;

const RULES: Array<{ test: RegExp; message: string }> = [
  {
    test: /no email (item|selected)|mailbox not ready|open an email first/i,
    message: errorStrings.noItem,
  },
  { test: /cannot resolve thread for this draft/i, message: errorStrings.draft },
  { test: /email not found|\b404\b/i, message: errorStrings.notFound },
  {
    test: /failed to fetch|networkerror|network request failed|load failed|timed? ?out|\b5\d\d\b/i,
    message: errorStrings.network,
  },
];

/** Maps a raw error string to short, user-facing copy. Falls back to a generic message. */
export function friendlyErrorMessage(raw: string | null | undefined): string {
  const text = typeof raw === "string" ? raw.trim() : "";

  if (!text) return errorStrings.generic;
  return RULES.find((rule) => rule.test.test(text))?.message ?? errorStrings.generic;
}
